module.exports = __webpack_public_path__ + "media/images/ideal-vision-center@2x-16e577b2b9a2e5980791212a992b4cb2.webp";